import React from "react"

import ScheduleView from "../schedule/ScheduleView"

interface DeliveryScheduleContentProps {
  selectedDate: Date
  onSelectedDateChange: (date: Date) => void
}

const DeliveryScheduleContent: React.FC<DeliveryScheduleContentProps> = ({
  selectedDate,
  onSelectedDateChange,
}) => {
  return (
    <ScheduleView
      scheduleType="delivery"
      selectedDate={selectedDate}
      onSelectedDateChange={onSelectedDateChange}
    />
  )
}

export default DeliveryScheduleContent
